import Button from '@mui/material/Button';
import { useEffect, useReducer, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Icon from '/@/components/icon';
import NewFieldInfo from '/@/components/new-field-info';
import { _ } from '/@/locale';
import { updateFieldFromAPI } from '/@/store/fields/apiProviders';
import { getSessionCountry } from '/@/store/session/selectors';
import { mpTrackEvent } from '/@/store/tracking/mixpanel-events';
import { setField } from '/@/store/weather/actions';
import { isMobile } from '/@/utils';
import styles from './styles.module.css';

const FieldEdit = ({ goBack, field, deleteField }) => {
    const [newField, setNewField] = useState(field);
    const [disabled, setDisabled] = useState(true);
    const [form, formDispatch] = useReducer(
        (state, { reset = undefined, name, value }) => {
            if (reset) {
                setDisabled(true);
                return { name: field.name };
            }
            if (value.length > 50 || !value) {
                setDisabled(true);
            } else setDisabled(false);
            return {
                ...state,
                [name]: value,
            };
        },
        { name: field.name }
    );
    const dispatch = useDispatch();

    useEffect(() => {
        formDispatch({ reset: true });
    }, [newField]);

    const country = useSelector(getSessionCountry);

    const handleSave = async () => {
        await updateFieldFromAPI({
            fieldId: field.id,
            country: country.code,
            name: form.name || field.name,
            enableFrostRiskNotification: form.enableFrostRiskNotification || field.enableFrostRiskNotification,
        });
        mpTrackEvent('Field edited', undefined);
        setNewField({
            ...field,
            country: country.id,
            ...form,
        });
        await dispatch(setField(field.id));

        if (isMobile()) {
            goBack();
        }
    };

    return (
        <div className={styles.root}>
            <div>
                <div className={styles.header}>
                    <div className={styles.label}>{_('Información de mi lote')}</div>
                    {goBack && <Icon type='arrow' size='xs' className={styles.goBack} onClick={() => goBack()} />}
                </div>
                <div className={styles.dataContainer}>
                    <NewFieldInfo form={form} handleChange={formDispatch} view='sidebar' field={field} edit />
                </div>
            </div>
            <div className={styles.btnContainer}>
                <Button variant='contained' disabled={disabled} onClick={handleSave}>
                    {_('Guardar Cambios')}
                </Button>
                <Button variant='outlined' onClick={() => deleteField()}>
                    {_('Eliminar lote')}
                </Button>
            </div>
        </div>
    );
};

export default FieldEdit;
